const data = 
[
    {
        "brand": "Sony",
        "camera": "RX100 Ⅲ",
        "cameraSize": "RX100 Ⅲ  101.6 x 58.1 x 41.0 mm 290g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅳ",
        "cameraSize": "RX100 IV  101.6×58.1×41.0 mm 298g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅴ",
        "cameraSize": "RX100 V   101.6×58.1×41.0mm  299g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "RX100 VA",
        "cameraSize": "RX100M5A   101.6 x 58.1 x 41.0 mm  299g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅵ",
        "cameraSize": "RX100 VI  101.6×58.1×42.8mm  301g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "RX100 Ⅶ",
        "cameraSize": "RX100 VII 101.6×58.0×42.8mm  302g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5mm*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "FE 85mm f/1.8",
        "cameraLenSize": "Φ78mm*82mm，371g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "E 10-18mm f/4 OSS",
        "cameraLenSize": "Φ70*63.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "T* E 24mm f/1.8 ZA",
        "cameraLenSize": "Φ63*65.5mm,225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "Sigma 30mm F1.4 DC DN",
        "cameraLenSize": "Φ64.8*73.3mm,265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "ND lens required"
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "laowa 9mm 2.8",
        "cameraLenSize": "Φ60*53mm,215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6700",
        "cameraSize": "A6700 122×69×75.1mm  493g",
        "cameraLen": "E 18-135mm F3.5-5.6",
        "cameraLenSize": "Φ67.2*88mm，325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "A7S2  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "A7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "A7S   126.9×94.4×48.2mm 446g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "A7R   126.9×94.4×48.2mm 407g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7",
        "cameraSize": "A7    126.7×94.4×48.2mm 416g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7C",
        "cameraSize": "A7C   124×71.1×59.7mm,509g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "A7 III 126.9×95.6×73.7mm,650g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 55mm f/1.8",
        "cameraLenSize": "Φ64*71mm,281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 35mm f/2.8",
        "cameraLenSize": "Φ61.5*36.5mm,120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE28-70mm f/3.5-5.6",
        "cameraLenSize": "Φ72.5*83mm,295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm,167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 50mm F1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm,186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "Tamron 20-40mm F2.8 Di III VXD",
        "cameraLenSize": "Φ67 x 86.5 365g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "A72   126.9×95.7×59.7mm  556g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A5100",
        "cameraSize": "109.6×62.8×35.7mm,283g",
        "cameraLen": "PZ 16-50mm f/3.5-5.6",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "DSC-RX0",
        "cameraSize": "59×40.5×29.8mm,110g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "DSC-RX0 Ⅱ",
        "cameraSize": "59×40.5×29.8mm,110g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "DSC-HX90",
        "cameraSize": "102×58.1×35.5mm,245g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "DSC-WX500",
        "cameraSize": "101.6 x 58.1 x 35.5 mm,236g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "ZV-1",
        "cameraSize": "105.4x60.0x44.0mm,294g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "ZV-E10",
        "cameraSize": "115.0*64.0*45.0mm,343g",
        "cameraLen": "E PZ 16-50/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7*29.9mm,116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "ZV-E10",
        "cameraSize": "115.0*64.0*45.0mm,343g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "ZV-E10",
        "cameraSize": "115.0*64.0*45.0mm,343g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "129.0×97.0×81.0mm  699g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5*88.1mm, 353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector,lens holder required"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "cameraSize": "128.9mm x 96.4mm x 77.5mm 580g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "cameraSize": "128.9mm x 96.4mm x 77.5mm 580g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "cameraSize": "128.9mm x 96.4mm x 77.5mm 580g",
        "cameraLen": "FE 50mm f/1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm  186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "cameraSize": "129×97×81mm  699g",
        "cameraLen": "FE 28-60mm F4-5.6",
        "cameraLenSize": "Φ66.6 x 45 167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "cameraSize": "129×97×81mm  699g",
        "cameraLen": "Sigma FE 35mm F2 DG DN",
        "cameraLenSize": "Φ70mm*67.4mm 384g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "cameraSize": "129×97×81mm  699g",
        "cameraLen": "FE 50mm f/1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm  186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "M50",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 11-22mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ60.9×58.2mm 220g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "M50",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 15-45mm F3.5-6.3 IS",
        "cameraLenSize": "Φ60.9mm*44.5mm   130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "M50",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 22mm f/2 STM",
        "cameraLenSize": "Φ60.9×23.7mm 105g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "M50",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 32mm f/1.4 STM",
        "cameraLenSize": "Φ60.9×56.5mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 11-22mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ60.9×58.2mm 220g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 15-45mm F3.5-6.3 IS",
        "cameraLenSize": "Φ60.9mm*44.5mm   130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 22mm f/2 STM",
        "cameraLenSize": "Φ60.9×23.7mm 105g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "cameraSize": "116.3×88.1×58.7mm,387g",
        "cameraLen": "EF-M 32mm f/1.4 STM",
        "cameraLenSize": "Φ60.9×56.5mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "Powershot G7 X Mark Ⅲ",
        "cameraSize": "105×60.9×41.4mm,304g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6",
        "cameraSize": "112×68×44.5mm，343g",
        "cameraLen": "EF-M 15-45mm F3.5-6.3 IS",
        "cameraLenSize": "Φ60.9mm*44.5mm   130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6",
        "cameraSize": "112×68×44.5mm，343g",
        "cameraLen": "EF-M 22mm f/2 STM",
        "cameraLenSize": "Φ60.9×23.7mm 105g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6",
        "cameraSize": "112×68×44.5mm，343g",
        "cameraLen": "EF-M 32mm f/1.4 STM",
        "cameraLenSize": "Φ60.9×56.5mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6",
        "cameraSize": "112×68×44.5mm，343g",
        "cameraLen": "EF-M 11-22mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ60.9×58.2mm 220g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "cameraSize": "119.6×70×49.2mm,408g",
        "cameraLen": "EF-M 15-45mm F3.5-6.3 IS",
        "cameraLenSize": "Φ60.9mm*44.5mm   130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "cameraSize": "119.6×70×49.2mm,408g",
        "cameraLen": "EF-M 22mm f/2 STM",
        "cameraLenSize": "Φ60.9×23.7mm 105g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "cameraSize": "119.6×70×49.2mm,408g",
        "cameraLen": "EF-M 32mm f/1.4 STM",
        "cameraLenSize": "Φ60.9×56.5mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "cameraSize": "119.6×70×49.2mm,408g",
        "cameraLen": "EF-M 11-22mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ60.9×58.2mm 220g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 200D Ⅱ",
        "cameraSize": "122.4×92.6×69.8mm，410g",
        "cameraLen": "EF-S 18-55mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ66.5mm*61.8mm   215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "132.5×85×70mm,485g",
        "cameraLen": "EF 50mm f/1.4 USM",
        "cameraLenSize": "Φ73.8*50.5mm    290g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "135.8×98.3×84.4mm 660g",
        "cameraLen": "35mm f/1.8 Macro IS STM",
        "cameraLenSize": "Φ74.4mm*62.8mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "138.4×97.5×88.4mm 680g",
        "cameraLen": "RF50mm F1.8 STM",
        "cameraLenSize": "Φ69.2*40.5mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "R7   132×90.4×91.7mm  612g",
        "cameraLen": "RF-S18-150mm F3.5-6.3 IS STM",
        "cameraLenSize": "Φ69*84.5mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "Need to remove the viewfinder's protector, camera/lens will hit the roll axis"
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "R7   132×90.4×91.7mm  612g",
        "cameraLen": "RF35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4*62.8mm 305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "R7   132×90.4×91.7mm  612g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF-S18-150mm F3.5-6.3 IS STM",
        "cameraLenSize": "Φ69*84.5mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "Need to remove the viewfinder's protector, camera/lens will hit the roll axis"
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4*62.8mm 305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R8",
        "cameraSize": "EOS R8  132.5×86.1×70mm  461g",
        "cameraLen": "RF24-50mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69.6mm*58mm  210g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R50",
        "cameraSize": "EOS R50  116.3×85.5×68.8mm  376g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6 Mark Ⅱ",
        "cameraSize": "EOS R6 Mark II  138.4×98.4×88.4mm 670g",
        "cameraLen": "RF24mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4×63.1mm  270g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.00",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 f/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58*36*46mm  115g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "Lumix G 25mm f/1.7",
        "cameraLenSize": "Φ60.8mm*52mm  125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "LUMIX G MACRO 30mm f/2.8 ASPH MEGA OIS",
        "cameraLenSize": "Φ58.8mm*63.5mm  180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   132.9x93.4×83.9mm,560g",
        "cameraLen": "H-FS1442A",
        "cameraLenSize": "Φ56mm*49mm  110g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.00",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 f/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58*36*46mm  115g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "Lumix G 25mm f/1.7",
        "cameraLenSize": "Φ60.8mm*52mm  125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LUMIX G MACRO 30mm f/2.8 ASPH MEGA OIS",
        "cameraLenSize": "Φ58.8mm*63.5mm  180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "H-FS1442A",
        "cameraLenSize": "Φ56mm*49mm  110g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.00",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 f/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58*36*46mm  115g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "Lumix G 25mm f/1.7",
        "cameraLenSize": "Φ60.8mm*52mm  125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LUMIX G MACRO 30mm f/2.8 ASPH MEGA OIS",
        "cameraLenSize": "Φ58.8mm*63.5mm  180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "H-FS1442A",
        "cameraLenSize": "Φ56mm*49mm  110g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "S5 Ⅱ",
        "cameraSize": "102.3×134.3×90.1mm  740g",
        "cameraLen": "L 35mm F1.8",
        "cameraLenSize": "73.6mm*82mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "×",
        "horizontallyLong": "×",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5",
        "cameraSize": "X-A5  116.9×67.7×40.4mm，361g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A7",
        "cameraSize": "X-A7  119×67.7×41.1mm，320g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4x82.8x41.4mm，333g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 Ⅱ 118×83×47mm，383g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100 121.0 x 83.0 x 47.4mm,448g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200 121×83.7×55.1mm，370g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20 127.7×85.1×65.4mm 410g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30 118.4×82.8×46.8mm,383g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 18-55mm f/2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm   310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XF18mmF2 R",
        "cameraLenSize": "ø64.5mm*40.6mm 116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4   134.6×92.8×63.8mm  607g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XF 18-55mm f/2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm   310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XF18mmF2 R",
        "cameraLenSize": "ø64.5mm*40.6mm 116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm,539g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XF 18-55mm f/2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm   310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XF18mmF2 R",
        "cameraLenSize": "ø64.5mm*40.6mm 116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1 139.8×97.3×85.5mm,673g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF 18-55mm f/2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm   310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XC 15-45mm F3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS II",
        "cameraLenSize": "Φ118.4*82.8*41.4mm  383g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "×",
        "verticalShort": "√",
        "verticalLong": "×",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF16mmF2.8 R WR",
        "cameraLenSize": "ø60.0mm*45.4mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF14mmF2.8 R",
        "cameraLenSize": "65mm*58.4mm 235g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF8mmF3.5 R WR",
        "cameraLenSize": "Ø68mm*52.8mm 215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF18mmF2 R",
        "cameraLenSize": "ø64.5mm*40.6mm 116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF23mmF2 R WR",
        "cameraLenSize": "ø60.0mm*51.9mm 180g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-E3",
        "cameraSize": "X-E3 121.3×42.7×73.9mm 337g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X100V",
        "cameraSize": "X100V 128×74.8×53.3mm 478g",
        "cameraLen": "套机",
        "cameraLenSize": "——",
        "mountingStatue": "单机 + 镜头",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z DX 16-50mm f/3.5-6.3 VR",
        "cameraLenSize": "Φ70mm*32mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z DX 24mm f/1.7",
        "cameraLenSize": "70mm*40mm 135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "Viltrox Z 23mm F1.4",
        "cameraLenSize": "73mm*69mm320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z DX 16-50mm f/3.5-6.3 VR",
        "cameraLenSize": "Φ70mm*32mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z DX 24mm f/1.7",
        "cameraLenSize": "70mm*40mm 135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "Viltrox Z 23mm F1.4",
        "cameraLenSize": "73mm*69mm320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z DX 16-50mm f/3.5-6.3 VR",
        "cameraLenSize": "Φ70mm*32mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z DX 24mm f/1.7",
        "cameraLenSize": "70mm*40mm 135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50   126.5×93.5×60mm  395g",
        "cameraLen": "Viltrox Z 23mm F1.4",
        "cameraLenSize": "73mm*69mm320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "cameraSize": "Z5  134×100.5×69.5mm  675g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "cameraSize": "Z5  134×100.5×69.5mm  675g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "cameraSize": "Z5  134×100.5×69.5mm  675g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "cameraSize": "Z5  134×100.5×69.5mm  675g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "cameraSize": "Z5  134×100.5×69.5mm  675g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7Ⅱ 134×100.5×67.5mm  705g",
        "cameraLen": "Nikkor Z FX 24-50mm f/4-6.3",
        "cameraLenSize": "73.5mm*51mm 195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7Ⅱ 134×100.5×67.5mm  705g",
        "cameraLen": "Nikkor Z 40mm f/2 (SE)",
        "cameraLenSize": "71.5mm *45.5mm 170g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7Ⅱ 134×100.5×67.5mm  705g",
        "cameraLen": "Nikkor Z 28mm f/2.8",
        "cameraLenSize": "70mm*43mm 155g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7Ⅱ 134×100.5×67.5mm  705g",
        "cameraLen": "Nikkor Z 26mm f/2.8",
        "cameraLenSize": "70 mm*23.5mm 125g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7Ⅱ 134×100.5×67.5mm  705g",
        "cameraLen": "Nikkor Z 50mm f/2.8",
        "cameraLenSize": "74.5mm*66mm 260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Need to remove the viewfinder's protector"
    },
    {
        "brand": "SIGMA",
        "camera": "FP",
        "cameraSize": "112.6×69.9×45.3mm 422g",
        "cameraLen": "Sigma 45mm f/2.8 DG DN",
        "cameraLenSize": "Φ64mm*46.2mm  215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro5",
        "cameraSize": "62×44.6×33.7mm  112.5g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro6",
        "cameraSize": "62×44.6×33.7mm  115.3g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 SILVER",
        "cameraSize": "62.3×44.9×28.3 mm  94.2g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 Black",
        "cameraSize": "62×33.7×44.6mm  111.3g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro7 White",
        "cameraSize": "62.3×44.9×28.3 mm  92.3g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro8 Black",
        "cameraSize": "66.3×48.6×28.4mm  124.5g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro9 Black",
        "cameraSize": "71.8×50.8×33.6mm  158.5g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro10 Black",
        "cameraSize": "71.8×50.8×33.6mm  159.6g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro11",
        "cameraSize": "71.8×50.8×33.6mm  153.2g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "GoPro",
        "camera": "GoPro Max",
        "cameraSize": "64×69×25mm  163.1g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    }
]

export default data